import * as awsui from '@amzn/awsui-design-tokens/polaris';

// https://cloudscape.aws.dev/foundation/visual-foundation/data-vis-colors/
export const chartColorsLight = [
    awsui.colorChartsBlue2300,
    awsui.colorChartsPink500,
    awsui.colorChartsTeal300,
    awsui.colorChartsPurple500,
    awsui.colorChartsOrange300,
    awsui.colorChartsBlue2600,
    awsui.colorChartsPink800,
    awsui.colorChartsTeal600,
    awsui.colorChartsPurple800,
    awsui.colorChartsOrange600,
    awsui.colorChartsBlue2900,
    awsui.colorChartsPink1100,
    awsui.colorChartsTeal900,
    awsui.colorChartsPurple1100,
    awsui.colorChartsOrange900,
    awsui.colorChartsBlue21200,
    awsui.colorChartsPink400,
    awsui.colorChartsTeal1200,
    awsui.colorChartsPurple400,
    awsui.colorChartsOrange1200,
    awsui.colorChartsBlue2500,
    awsui.colorChartsPink700,
    awsui.colorChartsTeal500,
    awsui.colorChartsPurple700,
    awsui.colorChartsOrange500,
    awsui.colorChartsBlue2800,
    awsui.colorChartsPink1000,
    awsui.colorChartsTeal800,
    awsui.colorChartsPurple1000,
    awsui.colorChartsOrange800,
    awsui.colorChartsBlue21100,
    awsui.colorChartsPink300,
    awsui.colorChartsTeal1100,
    awsui.colorChartsPurple300,
    awsui.colorChartsOrange1100,
    awsui.colorChartsBlue2400,
    awsui.colorChartsPink600,
    awsui.colorChartsTeal400,
    awsui.colorChartsPurple600,
    awsui.colorChartsOrange400,
    awsui.colorChartsBlue2700,
    awsui.colorChartsPink900,
    awsui.colorChartsTeal700,
    awsui.colorChartsPurple900,
    awsui.colorChartsOrange700,
    awsui.colorChartsBlue21000,
    awsui.colorChartsPink1200,
    awsui.colorChartsTeal1000,
    awsui.colorChartsPurple1200,
    awsui.colorChartsOrange1000,
];
